const perfix = "v1/"

export const endpoints = {
  // Authentication endpoints (no v1/ prefix for auth)
  login: "Auth/login",
  logout: "Auth/logout",
  refreshToken: "Auth/refresh-token",

  // Products endpoints
  getProducts: perfix + "vendor/products",
  getProductById: (id: number) => perfix + `vendor/products/${id}`,
  createProduct: perfix + "vendor/products",
  updateProduct: (id: number) => perfix + `vendor/products/${id}`,
  deleteProduct: (id: number) => perfix + `vendor/products/${id}`,
  attachProductImage: (id: number, isPrimary: boolean) => perfix + `vendor/products/${id}/images?isPrimary=${isPrimary}`,
  uploadProductImage: (id: number) => perfix + `vendor/products/${id}/images/upload`,
  updateProductInventory: (id: number) => perfix + `vendor/products/${id}/inventory`,

  // Product Categories endpoints
  getAllProductCategories: perfix + "categories",
  getProductCategoryById: (id: number) => perfix + `categories/${id}`,
  createProductCategory: perfix + "categories",
  updateProductCategory: (id: number) => perfix + `categories/${id}`,
  deleteProductCategory: (
    id: number,
    mode?: string,
    moveToCategoryId?: number
  ) =>
    mode
      ? perfix +
        `categories/${id}?mode=${mode}${
          moveToCategoryId ? `&moveToCategoryId=${moveToCategoryId}` : ""
        }`
      : perfix + `categories/${id}`,
  toggleProductCategoryStatus: (id: number) =>
    perfix + `categories/${id}/toggle`,
  getProductsByCategoryId: (id: number) =>
    perfix + `categories/${id}/Products`,

  // Delivery Men endpoints
  getDeliveryMen: perfix + "vendor/delivery-men",
  getDeliveryManById: (id: number) => perfix + `vendor/delivery-men/${id}`,
  createDeliveryMan: perfix + "vendor/delivery-men",
  updateDeliveryMan: (id: number) => perfix + `vendor/delivery-men/${id}`,
  deleteDeliveryMan: (id: number) => perfix + `vendor/delivery-men/${id}`,

  // Coupons endpoints
  getCoupons: perfix + "vendor/coupons",
  getCouponById: (id: number) => perfix + `vendor/coupons/${id}`,
  createCoupon: perfix + "vendor/coupons",
  updateCoupon: (id: number) => perfix + `vendor/coupons/${id}`,
  deleteCoupon: (id: number) => perfix + `vendor/coupons/${id}`,

  // Discount Types endpoints
  getDiscountTypes: perfix + "vendor/discount-types",
  createDiscountType: perfix + "vendor/discount-types",

  // Orders endpoints
  getOrders: perfix + "vendor/orders",
  getOrderById: (id: number) => perfix + `vendor/orders/${id}`,
  updateOrderStatus: (id: number) => perfix + `vendor/orders/${id}/status`,
  orderConfirmation: (id: number) => perfix + `vendor/orders/${id}/confirmation`,

  // Disputes endpoints
  getDisputes: perfix + "vendor/disputes",
  getDisputeById: (id: number) => perfix + `vendor/disputes/${id}`,
  createDispute: perfix + "vendor/disputes",
  updateDispute: (id: number) => perfix + `vendor/disputes/${id}`,
  deleteDispute: (id: number) => perfix + `vendor/disputes/${id}`,
  changeDisputeStatus: (id: number) => perfix + `vendor/disputes/${id}/ChangeStatus`,
  addDisputeLog: (id: number) => perfix + `vendor/disputes/${id}/Logs`,
  respondToDispute: (id: number) => perfix + `vendor/disputes/${id}/respond`,
  rejectDispute: (id: number) => perfix + `vendor/disputes/${id}/reject`,
}